const getters = {
  permission_routes: state => state.permission_routes.routes,
  isCollapse: state => state.is_collapse.isCollapse,
  userinfo: state => state.userinfo,
  userlogin_doc: state => state.userlogin_doc
};

export default getters;
